<template>
    <div>
        <tab name="1"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="项目名称" :value="1"></el-option>
                            <el-option label="项目ID" :value="2"></el-option>
                            <el-option label="发起人ID" :value="3"></el-option>
                            <el-option label="发起人名称" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.raiseType" placeholder="请选择类型" size="small">
                        <el-option label="所有类型" value=""></el-option>
                        <el-option label="唱片专辑" :value="1"></el-option>
                        <el-option label="音乐周边" :value="2"></el-option>
                        <el-option label="其它" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择状态" size="small">
                        <el-option label="所有状态" value=""></el-option>
                        <!-- <el-option label="发布中" :value="0"></el-option> -->
                        <el-option label="未开始" :value="101"></el-option>
                        <el-option label="待审核" :value="1"></el-option>
                        <el-option label="众筹中" :value="2"></el-option>
                        <el-option label="已结束" :value="3"></el-option>
                        <el-option label="已完成" :value="4"></el-option>
                        <el-option label="审核未通过" :value="5"></el-option>
                        <el-option label="已取消" :value="6"></el-option>
                        <el-option label="已失败" :value="7"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择优先级" size="small">
                        <el-option label="优先展示最新发起的项目" :value="1"></el-option>
                        <el-option label="优先展示最早结束的项目" :value="2"></el-option>
                        <el-option label="优先展示最早开始的项目" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="raiseType" label="众筹类型">
                    <template slot-scope="scope">
                        {{raiseType.get(scope.row.raiseType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" min-width="90">
                    <template slot-scope="scope">
                        <span v-if="raiseStatus" :class="raiseStatus.get(scope.row.status)[1]">{{raiseStatus.get(scope.row.status)[0]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="项目名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link class="ellipsis title" @click="$refs.H5Preview.show('/pages/raise/detail/detail?id='+scope.row.id)">
                            {{scope.row.title}}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="raiseMoneyFormat" label="目标筹款金额" min-width="120"></el-table-column>
                <el-table-column prop="raisedMoneyFormat" label="已经筹款金额" min-width="120"></el-table-column>
                <el-table-column prop="raiseRate" label="众筹进度">
                    <template slot-scope="scope">{{scope.row.raiseRate}}%</template>
                </el-table-column>
                <el-table-column prop="supportNum" label="支持次数" ></el-table-column>
                <el-table-column prop="startTime" label="预计开始时间" min-width="150"></el-table-column>
                <el-table-column prop="endTime" label="预计结束时间" min-width="150"></el-table-column>
                <el-table-column prop="promoterUserType" label="发起人身份" min-width="90">
                    <template slot-scope="scope">{{$userType.get(scope.row.promoterUserType)}}</template>
                </el-table-column>
                <el-table-column prop="promoter" label="发起人ID" min-width="90"></el-table-column>
                <el-table-column prop="promoterName" label="发起人名称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="onlineAuditTime" label="发起时间" min-width="150"></el-table-column>

                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/raise/info')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="(scope.row.status == 2 || scope.row.status == 3) && $utils.have('/raise/cancel')"
                            type="text"
                            size="small"
                            icon="el-icon-delete"
                            @click="$refs.raiseCancel.show(scope.row)"
                            >取消</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <RaiseCancel ref="raiseCancel" @onUpdate="getDataList"></RaiseCancel>
        <H5Preview ref="H5Preview"></H5Preview>
    </div>
</template>
<script>
import Tab from './components/tab'
import RaiseCancel from './components/raise-cancel'
import H5Preview from '@/components/H5Preview';
const defaultParams = {
    pageNo: 1,
    searchValue: '',
    searchType: 1,
    sort:1,
    status:"",
    raiseType:''
}
    export default {
        components:{Tab,RaiseCancel,H5Preview},
        data(){
            return {
                data: null,
                dataList: null,
                params: {
                    ...defaultParams,
                    pageNo: parseInt(this.$route.query.pageNo || 1),
                    pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                    searchValue: this.$route.query.searchValue || '',
                    searchType:parseInt(this.$route.query.searchType || 1),
                    sort:parseInt(this.$route.query.sort || 1),
                    status: this.$route.query.status ? parseInt(this.$route.query.status) : '',
                    raiseType: this.$route.query.raiseType ? parseInt(this.$route.query.raiseType) : '',
                },
                listLoading: true,
            }
        },
        computed:{
            raiseType(){
                return new Map([
                    [1,'唱片专辑'],
                    [2,'音乐周边'],
                    [3,'其它']
                ])
            },
            raiseStatus(){
                return new Map([
                    [0,['发布中','']],
                    [1,['待审核','color-warning']],
                    [2,['众筹中','color-success']],
                    [3,['已结束','']],
                    [4,['已完成','']],
                    [5,['未通过','color-danger']],
                    [6,['已取消','color-info']],
                    [7,['已失败','']],
                    [101,['未开始','']]
                ])
            }
        },
        mounted(){
            this.getDataList();
        },
        methods:{
            //获取列表
            getDataList(){
                this.listLoading = true;
                this.$request({
                    url: '/raise/list',
                    method: 'POST',
                    data: this.params
                }).then(res => {
                    const { state, msg, result } = res.data;
                    if( state == 1 && result ){
                        this.data = result;
                        this.dataList = result.result || [];
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            },
            //选择pageSize
            handleSizeChange( e ){
                this.params.pageNo = 1
                this.params.pageSize = e
                this.getDataList()
            },
            //搜索
            search() {
                this.params.pageNo = 1;
                this.getDataList();
            },
            //重置搜索
            reset() {
                this.params = {
                    ...defaultParams,
                    pageSize: this.params.pageSize
                }
                this.getDataList();
            },
            //编辑事件
            edit(id) {
                this.$router.push({
                    path: `/raise/project/edit/baseInfo/${id}`,
                    query: {
                        v: this.$utils.uuid(),
                        redirect: this.$utils.objArgs(
                            this.$router.currentRoute.path,
                            this.params
                        ),
                    },
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>